export const SELECTED_CONFIG_KEY = (productId) =>
    `configurator/selectedConfig#${productId}`